export default __webpack_public_path__ + "static/1.7.6/media/loginimage.0fede9a4.svg";